import { AccordionHtmlContent } from "@/components/catalogue/AccordionHtmlContent";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface ExhibitionsAccordionProps {
  exhibitionsCalculated: string | null;
  t: (key: string) => string;
}

export function ExhibitionsAccordion({
  exhibitionsCalculated,
  t,
}: ExhibitionsAccordionProps) {
  if (!exhibitionsCalculated) return null;

  return (
    <AccordionItem value="expositions">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleArtworkSubtitleExhibition")}
      </AccordionTrigger>
      <AccordionContent>
        <AccordionHtmlContent html={exhibitionsCalculated} richText />
      </AccordionContent>
    </AccordionItem>
  );
}
